import React, { useCallback } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { INNOVATION_ROUTES } from "../../../routes";
import { PersistedExperimentParticipantPreview } from "../components/preview/PersistedExperimentParticipantPreview";

export const ExperimentCustomerPreviewPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const handleFinish = useCallback(
    (
      _submissionPayload: Parameters<
        React.ComponentProps<typeof PersistedExperimentParticipantPreview>["onFinish"]
      >[0],
    ) => {
      window.alert("Thank you for your feedback! Your responses have been recorded.");
      navigate(INNOVATION_ROUTES.HOME);
    },
    [navigate],
  );

  return (
    <PersistedExperimentParticipantPreview
      experimentId={id}
      mode="route"
      onBack={() => navigate(INNOVATION_ROUTES.HOME)}
      onFinish={handleFinish}
    />
  );
};

export default ExperimentCustomerPreviewPage;
